"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserOrganisations = exports.getUsersLinkedToOrganisation = exports.getOrganisationRootsForUser = exports.getOrganisationSummary = exports.getOrganisationNode = void 0;
const axios_1 = __importDefault(require("axios"));
const baseUrl = '/https2-organisation';
async function getOrganisationNode(organisationId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/organisations/${organisationId}/nodes`
    });
    return resp.data;
}
exports.getOrganisationNode = getOrganisationNode;
async function getOrganisationSummary(organisationId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/organisations/${organisationId}/summary`
    });
    return resp.data;
}
exports.getOrganisationSummary = getOrganisationSummary;
async function getOrganisationRootsForUser() {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/organisations/roots`
    });
    return resp.data;
}
exports.getOrganisationRootsForUser = getOrganisationRootsForUser;
async function getUsersLinkedToOrganisation(organisationId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/organisations/${organisationId}/users`
    });
    return resp.data;
}
exports.getUsersLinkedToOrganisation = getUsersLinkedToOrganisation;
async function getUserOrganisations() {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/organisations/`
    });
    return resp.data;
}
exports.getUserOrganisations = getUserOrganisations;
